import React from 'react';

export const isItEaster = () => {
    const now = new Date();
    const currentYear = now.getFullYear();

    // Define Easter period - April 10 to April 27
    const startDate = new Date(currentYear, 3, 9); // April is month 3 (0-indexed)
    const endDate = new Date(currentYear, 3, 27);

    // Check if current date is within Easter period
    return now >= startDate && now <= endDate;
};

export const withEaster = <P extends unknown>(Component: React.ComponentType<P>) =>
    (props: P) => {
        return !!isItEaster() && <Component {...(props as any)} />;
    };
